import { CaseSpecification } from '../../../cases/CaseSpecification';
import { Project } from '../../../../project/Project';

export const isProjectInputModeGfsEff = (projectOrCase: Project | CaseSpecification) =>
  (projectOrCase as Project).surfaceInputMode === 'gfsEff' ||
  (projectOrCase as CaseSpecification).projectSurfaceInputMode === 'gfsEff';
